import { memo, useCallback } from 'react'
import { useDispatch, useSelector } from '@tabeeb/store'
import { setUserForSharing } from '@tabeeb/modules/contentSharings/actions'
import { getUserSearchState } from '@tabeeb/modules/contentSharings/selectors'
import { SearchResultRowBtn } from '@tabeeb/modules/contentSharings/constants/enums'
import { Stack } from '@collaborate-health/uikit'
import UserSearchResultItem from '../UserSearchResultItem'

const SearchUsersResult = () => {
  const dispatch = useDispatch()
  const { usersList } = useSelector(getUserSearchState)

  const _handleClick = useCallback(
    (user) => {
      dispatch(setUserForSharing(user))
    },
    [dispatch]
  )

  return (
    <Stack spacing={0.5}>
      {usersList.map((user) => (
        <UserSearchResultItem
          user={user}
          button={SearchResultRowBtn.Select}
          handleButtonClick={_handleClick}
          key={user.Id}
        />
      ))}
    </Stack>
  )
}

export default memo(SearchUsersResult)

